<template>
    <v-container>
        <v-card>
            <v-card-title style="display: flex;   flex-direction: row;  flex-wrap: nowrap;">
                <span class="font-weight-black text-h6">Lista de Centro de Emplazamientos</span>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab dark small color="#05435B" v-bind="attrs" v-on="on"
                            @click="dialog = true">
                            <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Agregar Nuevo Emplazamiento</span>
                </v-tooltip>
            </v-card-title>

            <v-data-table :headers="headers" :items="embarcs" item-value="id" class="elevation-2 custom-table" :mobile-breakpoint="0"
                :items-per-page="15" dense>
                <template v-slot:body="{ items }">
                    <tr v-for="(item, index) in items" :key="item.emplazamiento" class="hover-row">
                        <td class="emplazamiento-column">
                            <v-text-field v-if="editIndex === index" v-model="editedItem.emplazamiento" maxlength="100"
                                dense outlined hide-details></v-text-field>
                            <span v-else>{{ item.emplazamiento }}</span>
                        </td>
                        <td class="ejecucion-column">
                            <v-text-field v-if="editIndex === index" v-model="editedItem.denominacionEmplazamiento"
                                maxlength="50" dense outlined hide-details></v-text-field>
                            <span v-else>{{ item.denominacionEmplazamiento }}</span>
                        </td>

                        <td class="acciones-column text-right">
                            <v-btn v-if="editIndex !== index" icon color="blue" @click="editItem(index, item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn v-if="editIndex === index" icon color="green" @click="saveEdit(index)">
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn v-if="editIndex === index" icon color="red" @click="cancelEdit">
                                <v-icon>mdi-cancel</v-icon>
                            </v-btn>
                            <v-btn v-if="editIndex !== index" icon color="red" @click="removeItem(item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>

        <!-- Diálogo para agregar nueva embarcación -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>Agregar Nuevo Emplazamiento</v-card-title>
                <v-card-text>
                    <v-text-field v-model="newItem.emplazamiento" label="Emplazamiento" outlined dense></v-text-field>
                    <v-text-field v-model="newItem.denominacionEmplazamiento" label="Denominación de Emplazamiento" outlined
                        dense></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="addItem">Agregar</v-btn>
                    <v-btn text color="red" @click="dialog = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService';

export default {
    data() {
        return {
            dialog: false,
            editIndex: -1,
            editedItem: {},
            newItem: { emplazamiento: "", denominacionEmplazamiento: "" },
            embarcs: [],
            headers: [
                { text: "Emplazamiento", align: "center", value: "emplazamiento", sortable: true },
                { text: "Denominación Emplazamiento", align: "center", value: "denominacionEmplazamiento", sortable: true },
                { text: "Acciones", align: "center", value: "actions", align: "end", sortable: false },
            ],
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        async loadData() {
            SwalService.loading('Cargando..', 'Por favor espere.');
            try {
                const response = await apiService.get("/parameters/get-emplazamientos")
                if (response.data.emplazamientosList.length > 0) {
                    this.embarcs = response.data.emplazamientosList;
                } else {
                    this.embarcs = [];
                }
            } catch (error) {
                this.embarcs = [];

            } finally {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
            }

        },
        saveData() {
            localStorage.setItem("embarcs", JSON.stringify(this.embarcs));
        },
        async addItem() {
            if (this.newItem.emplazamiento && this.newItem.denominacionEmplazamiento) {
                //this.embarcs.push({ ...this.newItem });
                const exists = this.embarcs.some(item => item.emplazamiento === this.newItem.emplazamiento);

                if (exists) {
                    SwalService.alert('Emplazamiento Repetido', 'El emplazamiento ' + this.newItem.emplazamiento + ' ya existe, por favor ingresar un emplazamiento diferente.');
                    return;
                }
                try {
                    const response = await apiService.post("/parameters/register-emplazamientos", this.newItem)
                    if (response.data.success) {
                        SwalService.success('Emplazmiento registrado', 'Se creado correctamente el emplazamiento ' + this.newItem.emplazamiento);
                        this.embarcs = response.data.emplazamientosList;

                    }
                } catch (error) {

                } finally {

                }
                this.dialog = false;
                this.newItem = { emplazamiento: "", denominacionEmplazamiento: "" };
            } else {
                SwalService.alert('Campos Incompletos', 'Por favor ingrese todos los campos para poder registrar un emplzamiento.');
                return;
            }
        },
        async removeItem(item) {
            const result = await SwalService.confirm(
                '¿Estás seguro de eliminar el emplazamiento ' + item.emplazamiento + '?',
                'Esta acción eliminará el emplazamiento.',
                'warning',
                'Sí, eliminar',
                'Cancelar'
            );

            if (result.isConfirmed) {
                // Aquí eliminarías la embarcación
                // this.embarcs = this.embarcs.filter(item => item.id !== id);
                const response = await apiService.post("/parameters/delete-emplazamientos", item)
                if (response.data.success) {
                    SwalService.success('Emplazamiento eliminado', 'Se eliminado el emplazamiento ' + item.emplazamiento);
                    this.embarcs = response.data.emplazamientosList;
                    Swal.success('Eliminado', 'El emplazamiento ha sido eliminado.');
                }

            }

        },
        editItem(index, item) {
            this.editIndex = index;
            this.editedItem = { ...item }; // Clonar el objeto para edición
        },
        async saveEdit(index) {
            //this.embarcs[index] = { ...this.editedItem };
            try {
                const response = await apiService.post("/parameters/register-emplazamientos", this.editedItem)
                if (response.data.success) {
                    this.embarcs = response.data.emplazamientosList;
                }
            } catch (error) {

            } finally {

            }
            //this.saveData();
            this.editIndex = -1;
        },
        cancelEdit() {
            this.editIndex = -1;
        },
    },
};
</script>

<style scoped>
/* Estilos mejorados */
.v-data-table {
    border-radius: 10px;
    overflow: hidden;
}

.v-data-table>>>thead th {
    font-size: 18px !important;
    font-weight: bold;
    text-align: center !important;
    color: white !important;
    background-color: #05435B;
}
.v-data-table>>>thead th.sortable .v-data-table-header__icon {
    color: white !important;
    font-weight: 700;
}

td {
    text-align: center !important;
    border-bottom: 1px solid #ddd;
}

/* Efecto hover para filas */
.hover-row:hover {
    background-color: #f5f5f5;
    transition: background-color 0.3s ease;
}

/* Botón flotante para agregar */
.fab-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
}

.id-column {
    width: 10%;
    text-align: center;
}

.emplazamiento-column {
    width: 40%;
    text-align: center;
}

.ejecucion-column {
    width: 40%;
    text-align: center;
}
</style>
